<template>
  <div>
    <div v-show="!isLoaded">
      <Loading ref="loadingSpinner"></Loading>
    </div>
    <div v-if="isLoaded">
      <b-row class="pt-2">
        <b-col>
          <div>
            <h3>{{ title }}</h3>
          </div>
          <div class="float-right w-100">
            <DisplayCouverturesFilter ref="couvertureFilter" :runFilterAction="getData" />
          </div>
        </b-col>
      </b-row>

      <b-overlay :show="busy" rounded="sm">
        <b-row>
          <b-col md="3"><b>Nazwa</b></b-col>
          <b-col md="2"><b>Data ukończenia</b></b-col>
          <b-col md="3"><b>Waga początkowa / aktualna</b></b-col>
          <b-col md="4"><b>Akcje</b></b-col>
        </b-row>
        <b-row v-for="item in data" :key="item.id">
          <b-col md="3">
            <EcoConventionIcon :productType="item.recipe.recipeType" />
            {{ item.couvertureName }}
          </b-col>
          <b-col md="2">
            <span v-if="item.endDate">{{
              item.endDate | moment("DD-MM-YYYY HH:mm")
            }}</span>
            <span v-if="!item.endDate">Kuwertura nie ukończona</span>
          </b-col>
          <b-col md="3">{{item.initialWeight}} kg / {{ totalWeight(item.ingredients) }} kg</b-col>

          <b-col md="4">
            <div class="icons-row">
              <PackProductButton :recipe-type="recipeType.couverture" :product-id="item.id" v-if="item.weight > 0" />
              <b-button v-if="item.weight > 0" variant="primary" @click="ToggleModal(item)" v-b-tooltip.hover
                title="Umieść  w młynie">
                <i class="fas fa-arrows-down-to-line"></i></b-button>
              <HistoryButton :url="'#/HistoriaKuwertury/' + item.id" />
              <b-button v-if="item.weight > 0" variant="primary" class="mr-1 pointer" v-b-tooltip.hover
                title="Strata produktu" v-on:click="OpenModalMaterialLoss(item)">
                <i class="fas fa-trash"></i>
              </b-button>
            </div>
          </b-col>
          <DisplayCouverturesIngredients :indigrients="item.ingredients" />
          <b-col md="12">
            <hr />
          </b-col>
        </b-row>

        <b-pagination :total-rows="totalItemsCount" v-model="filter.currentPage" :per-page="filter.itemsPerPage"
          @change="pageChanged">
        </b-pagination>
      </b-overlay>
      <MaterialLoss ref="materialLossModal"/>
    </div>

    <b-modal no-close-on-backdrop v-model="modal.showModal" title="Dodawanie kuwertury do młynu" ok-title="Zapisz"
      cancel-title="Anuluj" @ok="AddCouvertureToMill()">
      <label>Wybierz młyn:</label>
      <v-select :options="mills" label="name" v-model="modal.selectedMill"></v-select>
    </b-modal>
  </div>
</template>

<script>
import Loading from "../Common/Loading";
import toastr from "../../mixins/toastr";
import MaterialLoss from '../Common/MaterialLoss.vue';
import DisplayCouverturesIngredients from './DisplayCouverturesIngredients.vue'
import recipesMixins from "../../mixins/recipes";
import EcoConventionIcon from '../../common/ecoConventionIcon.vue'
import DisplayCouverturesFilter from "./DisplayCouverturesFilter.vue";
import couvertureMixis from '../../mixins/couverture'
import HistoryButton from "../../common/HistoryButton.vue";
import PackProductButton from "@/common/PackProductButton.vue";

export default {
  name: "DisplayCouverture",
  components: {PackProductButton, Loading, MaterialLoss, DisplayCouverturesIngredients, EcoConventionIcon, DisplayCouverturesFilter, HistoryButton },
  mixins: [toastr, recipesMixins, couvertureMixis],
  computed: {
    mills() {
      return this.$store.state.couvertureFormData.mills;
    },

  },
  props: ["title"],
  mounted() {
    this.getData();
    this.$store.dispatch("getCuvertureFormData");
  },
  data() {
    return {
      busy: false,
      isLoaded: false,
      data: [],
      totalItemsCount: 0,
      filter: {
        itemsPerPage: 5,
        currentPage: 1,
      },
      modal: {
        name: this._uid,
        showModal: false,
        selectedMill: 0,
        couverture: 0,
      },
    };
  },
  methods: {
    OpenModalMaterialLoss(item) {
      this.$refs.materialLossModal.itemId = item.id;
      this.$refs.materialLossModal.itemName = `${item.couvertureName}`;
      this.$refs.materialLossModal.typeOfLoss = "couverture";

      this.$bvModal.show('MaterialLoss');
    },
    ToggleModal(couverture) {
      this.modal.showModal = !this.modal.showModal;
      this.modal.couverture = couverture;
    },
    AddCouvertureToMill() {
      var that = this;
      this.addCouvertureToMill(this.modal.couverture.id, this.modal.selectedMill.id)
        .then(function () {
          that.DisplaySuccess(
            "Sukces!",
            "Kuwertura " +
            that.modal.couverture.couvertureName +
            " została umieszczona w młynie " +
            that.modal.selectedMill.name
          );
          that.data = that.data.filter((x) => x.id != that.modal.couverture.id);

          that.modal.couverture = undefined;
          that.modal.selectedMill = undefined;
        })
        .catch(function (e) {
          that.DisplayError(
            "Błąd!",
            "Kuwertura " +
            that.modal.couverture.couvertureName +
            " nie została umieszczona w młynie " +
            that.modal.selectedMill.name +
            ". Możliwe ,że młyn jest już zajęty."
          );
          that.modal.couverture = undefined;
          that.modal.selectedMill = undefined;
          console.log(e);
        });
    },
    pageChanged(page) {
      this.filter.currentPage = page;
      this.getData();
    },
    getData(resetPage) {
      var that = this;
      this.busy = true;

      const page = resetPage ? 0 : this.filter.currentPage - 1;
      const productsFilter = that.$refs.couvertureFilter !== undefined
        ? that.$refs.couvertureFilter.couvertureViewFilter.value
        : 0;
      const searchTerm = that.$refs.couvertureFilter !== undefined
        ? that.$refs.couvertureFilter.searchTerm
        : '';
      const itemsPerPage = that.filter.itemsPerPage

      this.getCouvertures(page, itemsPerPage, productsFilter, searchTerm)
        .then((res) => {
          that.data = res.data.data;
          that.totalItemsCount = res.data.dataCount;
          that.isLoaded = true;
        })
        .catch((e) => {
          console.log(e);
          var ref = that.$refs.loadingSpinner;
          ref.ShowErrorMessage(e);
          that.isLoaded = false;
        })
        .finally(() => {
          that.busy = false;

        });
    },
    totalWeight(ingredients) {
      var result = 0;
      ingredients.forEach((element) => {
        result = result + element.weight;
      });

      return parseFloat(result).toFixed(3);
    },
  },
};
</script>